import { runWithAdal } from 'react-adal';
import { authContext } from './adalConfig';

const DO_NOT_LOGIN = false;

document.documentElement.lang = 'it';
const meta = document.createElement('meta');
meta.name = 'google';
meta.content = 'notranslate';
document.head.appendChild(meta);

runWithAdal(authContext, () => {

  // eslint-disable-next-line
  require('./indexApp.js');

},DO_NOT_LOGIN);